<template>
  <section class="section">
    <div class="container">
      <h2 class="header t-h2">Next up</h2>
      <Transition name="next-up">
        <ul
          v-if="!!nextUpsStore.currentNextUps.length"
          :key="id"
          class="list t-h2"
        >
          <li
            v-for="(nextUp, index) in nextUpsStore.currentNextUps"
            :key="index"
            class="row"
          >
            <div class="room">{{ nextUp.room }}</div>
            <div>{{ nextUp.course }}</div>
          </li>
        </ul>
        <p v-else class="msg t-h2">No more classes today!</p>
      </Transition>
    </div>
  </section>
</template>
<script setup lang="ts">
import { computed } from 'vue'

import { useNextUpsStore } from '@/stores/useNextUpsStore'

const nextUpsStore = useNextUpsStore()

const id = computed<string>(
  () =>
    nextUpsStore.currentNextUps.map(n => `${n.course}|${n.room}`).join() ||
    'empty'
)
</script>
<style lang="scss" scoped>
.header {
  margin-bottom: vh(20px);
  color: #ffffff;
}

.list {
  display: grid;
  grid-template-columns: vw(895px) vw(895px);
  margin-top: vh(50px);
  color: $text-paragraph-color;
}

.row {
  display: flex;
  flex-direction: row;
  align-items: baseline;
  margin-top: vh(4px);
  margin-bottom: vh(5px);
}

.room {
  width: vw(135px);
  overflow: hidden;
  font-weight: 400;
  text-overflow: ellipsis;
  text-transform: uppercase;
  white-space: nowrap;
}

.container {
  position: relative;
  width: 100%;
  height: vh(430px);
  margin-top: vh(50px);
  margin-left: vw(235px);
  overflow: hidden;
}

.next-up-section {
  position: absolute;
}

.next-up-enter-active {
  transition: 1.5s ease-out 0.5s;
  transition-property: opacity, transform;
}

.next-up-leave-active {
  transition: 0.5s ease-out;
  transition-property: opacity, transform;
}

.next-up-enter-from {
  opacity: 0;
  transform: translateY(vh(50px));
}

.next-up-leave-to {
  opacity: 0;
  transform: translateY(vh(-20px));
}

.msg {
  color: $text-paragraph-color;
}
</style>
